export default __webpack_public_path__ + "static/media/detoxdrinks@3x.c9e60c6b.jpg";